import api from 'api/api';

const BASE_URL = 'studio/memberships/';

export const fetchAllMemberships = async (sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(BASE_URL, { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error('Error al obtener membresías:', error);
    throw error;
  }
};